import React, { Fragment } from "react";

const IndustryEpisodesContainer = ({
  episode: { week, industrydescriptionname, poster, currentEpisode },
}) => {
  return (
    <Fragment>
      <div className="week-container">
        <p className="week-name">{week}</p>
      </div>
      <div className="week-info">
        <p className="industry">{industrydescriptionname}</p>
      </div>
      {currentEpisode ? (
        <img
          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/industry_of_week_images/${poster}`}
          className="week-image-active"
          alt=""
        />
      ) : (
        <img
          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/industry_of_week_images/${poster}`}
          className="week-image"
          alt=""
        />
      )}
    </Fragment>
  );
};

export default IndustryEpisodesContainer;
